import React from 'react';
import {Link, Text, View} from "@react-pdf/renderer";
import {BadgeIcon, SocialIcon} from "../../Icons";
import {SupportService} from "../../../../support";
import {ImageRender} from "../../Images";
import {withTranslation} from "react-i18next";

const Targets = ({t, data}) => {
  const {targets = []} = data;

  return (
    <View>
      <Text style={{marginBottom: '20px', fontFamily: 'pdfFont',}}>{t("Targets")}</Text>


      <View style={{display: 'flex', flexFlow: 'row', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'flex-start', alignItems: 'center'}}>
        {
          targets.map((res, idx) =>
            <View key={idx} style={{width: '150px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginRight: '10px', marginBottom: '10px'}}>
              <View>
                {ImageRender(res?.avatar || res.profileImageUrl)}
                {/*<Image style={{width: '50px', height: '50px', marginRight: '10px'}} src={res.profileImageUrl}/>*/}
              </View>
              <View>
                <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                  <BadgeIcon type={res.type} />
                  <Text style={{fontSize:'10px', fontWeight: '600', marginBottom: '5px', fontFamily: 'pdfFont',}}>{res.profileName}</Text>
                </View>
                <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                  <Link src={SupportService.getSocialProfileUrl(res.socialNetwork, res.profileId)} style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <SocialIcon network={res.socialNetwork} />
                    <Text style={{fontSize: '10px', fontFamily: 'pdfFont',}}>{res.profileId}</Text>
                  </Link>
                </View>
              </View>
            </View>
          )
        }
      </View>
      <Text break/>
    </View>
  );
};

export default withTranslation()(Targets);